import { render, staticRenderFns } from "./button.vue?vue&type=template&id=3ab8cd62&"
import script from "./button.vue?vue&type=script&lang=js&"
export * from "./button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangbin/workspace/project/bin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ab8cd62')) {
      api.createRecord('3ab8cd62', component.options)
    } else {
      api.reload('3ab8cd62', component.options)
    }
    module.hot.accept("./button.vue?vue&type=template&id=3ab8cd62&", function () {
      api.rerender('3ab8cd62', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/button/button.vue"
export default component.exports